import React from 'react';
import { FacetAccordion } from '@components';
import { Typography, Skeleton, Icon } from 'gd-design-library';
import styles from './CategoryTreeFacet.module.scss';
import classnames from 'classnames/bind';
import { Category } from '@services';
import Link from 'next/link';

const cx = classnames.bind(styles);

const CN = 'category-terms';
const categoryLabelClassName = `${CN}__category-label`;
const categoryPrimaryClassName = `${CN}__category-primary`;
const categoryCurrentClassName = `${CN}__category-current`;
const categoryItemClassName = `${CN}__category-item`;
const skeletonClassName = `${CN}__skeleton`;

interface Props {
  label: string;
  activeCategory: Category,
  childCategories: Category[],
  isLoading?: boolean;
  withAccordion?: boolean;
}

export const CategoryTreeFacet: React.FC<Props> = ({
  label,
  activeCategory,
  childCategories,
  isLoading,
  withAccordion = true
}) => {
  const parentOfParent = activeCategory?.parent?.parent ?? undefined;
  const parent = activeCategory?.parent ?? undefined;
  const getCategoryUrl = (key: string): string => (
    `/catalog/${key}`
  );

  const content = (
    <>
      <Typography className={ cx(categoryLabelClassName) }>Select a Different Category</Typography>
      <div>
        <ul>
          {parentOfParent &&
            <li className={ cx(categoryPrimaryClassName) }>
              <Link href={ getCategoryUrl(parentOfParent.key) }>
                <div>
                  <Icon name='arrowLeft' />
                  {parentOfParent.name}
                </div>
              </Link>
            </li>
          }
          {parent &&
            <li className={ cx(categoryPrimaryClassName) }>
              {parent?.id !== parentOfParent?.id ?
                (<>
                  <Link href={ getCategoryUrl(parent.key) }>
                    <Icon name='arrowLeft' />
                    {parent.name}
                  </Link>
                </>) :
                (<>
                  {parent.name}
                </>)
              }
            </li>
          }
          {activeCategory?.name && (
            <li className={ cx(categoryCurrentClassName) }>
              {activeCategory.name}
            </li>
          )}
          {!isLoading ? (
            childCategories && childCategories.map(({ id, name, productCount, key }) => (
              <li key={ id } className={ cx(categoryItemClassName) }>
                <Link href={ getCategoryUrl(key) }>{name}</Link>
                <span>{` (${productCount})`}</span>
              </li>
            ))
          ) : (
            <>
              <Skeleton height='30px' className={ cx(skeletonClassName) } />
              <Skeleton height='30px' className={ cx(skeletonClassName) } />
              <Skeleton height='30px' className={ cx(skeletonClassName) } />
              <Skeleton height='30px' className={ cx(skeletonClassName) } />
            </>
          )}
        </ul>
      </div>
    </>
  );

  return (
    withAccordion ? (
      <FacetAccordion label={ label }>
        { content }
      </FacetAccordion>
    ) : content
  );
};
